interface ToolCallDataListProps {
  items: Array<{ label: string; value: string }>;
}

export function ToolCallDataList({ items }: ToolCallDataListProps) {
  return (
    <div className="text-sm text-gray-700 space-y-2 pr-8">
      {items.map((item, index) => (
        <div
          key={index}
          className="flex justify-between items-baseline gap-2"
          data-testid={`tool-call-data-list-item-${index}`}
        >
          <span className="font-medium">{item.label}:</span>
          <span>{item.value}</span>
        </div>
      ))}
    </div>
  );
}
